import React from 'react'
import { observer } from 'mobx-react'

import Panel from './Panel'
import PanelHeader from './PanelHeader'
import Badge from './Badge'
import Button from './Button'

import './styles/panelAccordion.scss'

const Applied = ({ show }) => (
    !show
        ? null
        : (
            <Badge
                label="Applied"
                icon="fa-solid fa-check"
                cssClass="applied"
            />
        )
)

@observer
export default class PanelAccordion extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            showBody: false,
        }
    }

    renderButton = () => {
        const { showBody } = this.state
        const { ctaLabel, hasRules } = this.props

        const icon = showBody ? 'fa-light fa-chevron-up' : 'fa-light fa-chevron-down'
        const cssClass = hasRules ? 'primary' : 'secondary'

        return (
            <Button
                cssClass={`regular ${cssClass}`}
                label={ctaLabel}
                onClick={() => this.setState({ showBody: !showBody })}
                icon={icon}
            />
        )
    }

    render() {
        const { showBody } = this.state
        const {
            title,
            description,
            children,
            hasRules,
        } = this.props

        return (
            <Panel cssClass="panel-accordion-container">
                <PanelHeader noDivider>
                    <Applied show={hasRules} />

                    <h4>{title}</h4>

                    <div className="description-container">
                        <div className="description">
                            {description}
                        </div>

                        {this.renderButton()}
                    </div>
                </PanelHeader>

                {showBody && (
                    <div className="body">
                        {children}
                    </div>
                )}
            </Panel>
        )
    }
}
